import React, { useEffect, useState } from "react";
import { Modal, Checkbox, Typography } from "antd";
import PrimaryButton from "../Forms/PrimaryButton";
import DataTable from "../Tables/Datatable";
import SearchInput from "../Forms/SearchInput";

const { Title } = Typography;

export default function AssignClints({
  open,
  onClose,
  handleSubmit,
  title = "Assign Clients",
  buttonTitle = "Proceed",
  loading,
  width = 420,
  userData = [],
  selectedUserData = [],
  userType = "",
}) {
  const [selectedItems, setSelectedItems] = useState([]);
  const [search, setSearch] = useState("");
  const [userDataFinal, setUserDataFinal] = useState(userData || []);

  useEffect(() => {
    setUserDataFinal(userData);
  }, [userData, open]);

  useEffect(() => {
    if (open) {
      setSelectedItems(selectedUserData.map((item) => item));
      setSearch("");
    }
  }, [open, selectedUserData]);

  const toggleItem = (id) => {
    setSelectedItems((prev) => (prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]));
  };

  const selectAll = () => {
    if (selectedItems.length === userData.length && userData.length > 0) {
      setSelectedItems([]);
    } else {
      setSelectedItems(userData.map((i) => i.customer_id || i.user_id));
    }
  };

  const onProceed = () => {
    handleSubmit(selectedItems);
  };

  const handleSearchChange = (value) => {
    const val = value.toLowerCase();
    setSearch(val);
    if (userType === "customer") {
      const filtered = userData.filter((c) => c.company_name?.toLowerCase().includes(val?.trim()));
      setUserDataFinal(filtered);
    } else {
      const filtered = userData.filter((c) => c.full_name?.toLowerCase().includes(val?.trim()));
      setUserDataFinal(filtered);
    }
  };

  const columns = [
    {
      title: <span className="w-[25%] text-left font-medium text-gray-700">#</span>,
      render: (_, __, index) => <span className="font-normal text-black">{index + 1}</span>,
      width: 70,
    },
    {
      title: () => (
        <span className="text-gray-900 text-left font-normal w-[75%]">
          {userType === "customer" ? "Client Name" : "Salesperson Name"}
        </span>
      ),
      dataIndex: userType === "customer" ? "company_name" : "full_name",
      ellipsis: true,
    },
    {
      // title: (
      //   <Checkbox
      //     checked={selectedItems.length === userData.length && userData.length > 0}
      //     onChange={selectAll}
      //   />
      // ),
      width: 50,
      align: "center",
      render: (_, record) => (
        <Checkbox
          checked={selectedItems.includes(record.customer_id || record.user_id)}
          onChange={() => toggleItem(record.customer_id || record.user_id)}
        />
      ),
    },
  ];

  return (
    <Modal open={open} footer={null} onCancel={onClose} width={width} className="form-css-2">
      <div className="flex justify-between items-center mb-3">
        <Title level={2} className="text-3xl font-semibold text-gray-800 font-abhaya m-0">
          {title}
        </Title>
      </div>

      <SearchInput
        placeholder={`${userType === "customer" ? "Search for clients" : "Search for a salesperson"}`}
        onSearch={() => {}}
        value={search}
        onChange={(e) => handleSearchChange(e.target.value)}
        className="mb-4"
      />

      <DataTable
        rowKey={userType === "customer" ? "customer_id" : "user_id"}
        columns={columns}
        dataSource={userDataFinal}
        pagination={false}
        Showpagination={false}
        customEmptySection={userType === "customer" ? `Sorry, no clients found` : ` `}
        rootClassName="transparent-table"
      />

      <div className="flex justify-center mt-4">
        <PrimaryButton
          text={buttonTitle}
          loading={loading}
          // disabled={!selectedItems.length}
          onClick={onProceed}
          className="w-[160px]"
        />
      </div>
    </Modal>
  );
}
